import React from "react";
import { Link } from "react-router-dom";
import { HiArrowUpRight } from "react-icons/hi2";

/** Insight card: duotone photo that resolves to full colour on hover. */
export default function InsightCard({ post }) {
  return (
    <Link
      to={post.link}
      className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition duration-300 hover:-translate-y-1 hover:border-brand/40 hover:shadow-[0_28px_70px_-28px_rgba(36,87,245,0.4)]"
    >
      <div className="duotone aspect-[16/10]">
        <img
          src={post.image}
          alt={post.title}
          loading="lazy"
          width="640"
          height="400"
          className="h-full w-full object-cover group-hover:scale-105"
        />
        <span className="absolute left-4 top-4 z-10 rounded-full border border-white/25 bg-navy-950/60 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-white backdrop-blur">
          {post.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-7">
        <h3 className="font-display text-xl font-semibold leading-snug tracking-tight text-ink">{post.title}</h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>
        <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-5 text-xs text-slate-500">
          <span className="font-mono uppercase tracking-wider">{post.date}</span>
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-ink transition duration-300 group-hover:rotate-45 group-hover:border-brand group-hover:bg-brand group-hover:text-white">
            <HiArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </span>
        </div>
      </div>
    </Link>
  );
}
